import { render, staticRenderFns } from "./ClientCreate.vue?vue&type=template&id=a00aaa4a&"
import script from "./ClientCreate.vue?vue&type=script&lang=js&"
export * from "./ClientCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports